import { WorkData } from '../types';
import workspaceWiki from './work/cases/workspace-wiki';
import schnack from './work/cases/schnack';
import sphairaConnect from './work/cases/sphaira-connect';
// import flux from './work/cases/flux'; // offline, bis die App veröffentlicht ist
import hunyuan3dMlx from './work/cases/hunyuan3d-mlx';
import novatimepuncher from './work/cases/novatimepuncher';
// import kiKundendienstCockpit from './work/cases/ki-kundendienst-cockpit'; // offline bis Freigabe durch Arbeitgeber
import aiVideoTranscriptionAutomation from './work/cases/ai-video-transcription-automation';
import developmentOfRobinwichmannCom from './work/cases/development-of-robinwichmann_com';

const workData: WorkData = {
  title: "Meine Arbeiten",
  intro: "Hier findest Du eine Auswahl meiner aktuellen Projekte. Jedes Projekt steht für meinen Ansatz, innovatives Design mit technischer Exzellenz zu verbinden.",
  previewNotAvailable: "Vorschau nicht verfügbar",
  moreDetails: "Mehr Details",
  sections: {
    apps: {
      title: "Apps & Demos",
      intro: "Veröffentlichte Apps und ausprobierbare Projekte: gebaut, released und im Einsatz."
    },
    blog: {
      title: "Projektblog",
      intro: "Case Studies aus meiner Arbeit: Herausforderung, Lösungsweg und Ergebnisse im Detail."
    }
  },
  contactCta: {
    text: "Interessiert an einer Zusammenarbeit oder hast Du Fragen zu meinen Projekten?",
    buttonText: "Kontaktiere mich"
  },

  // Work Cases
  cases: [
    workspaceWiki,
    schnack,
    sphairaConnect,
    novatimepuncher,
    // flux, // offline, bis die App veröffentlicht ist
    hunyuan3dMlx,
    // kiKundendienstCockpit, // offline bis Freigabe durch Arbeitgeber
    developmentOfRobinwichmannCom,
    aiVideoTranscriptionAutomation
  ]
};

export default workData;
